import {
  AccountBalanceWallet,
  ArrowBack as ArrowBackIcon,
  PinDrop
} from "@mui/icons-material";
import { Drawer, IconButton, List } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // <-- v6

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  toggleSidebar,
  useLayoutDispatch,
  useLayoutState,
} from "../../context/LayoutContext";

const structure = [
  { id: 10, type: "title", label: "Portefeuille" },
  { id: 11, label: "Mon compte", link: "/app/Solde/show", icon: <AccountBalanceWallet /> },
  { id: 14, type: "divider" },
  { id: 6, type: "title", label: "Gestions" },
  { id: 20, label: "GPS", link: "/app/MesGPS", icon: <PinDrop /> },
  { id: 9, type: "divider" },
];

let user = JSON.parse(localStorage.getItem('user'));

function Sidebar() {
  const classes = useStyles();
  const theme = useTheme();

  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();

  const location = useLocation(); // <-- remplace props.location
  const navigate = useNavigate(); // <-- si tu veux naviguer depuis Sidebar

  const [isPermanent, setPermanent] = useState(true);

  useEffect(() => {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return () => {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  }, []);

  const renderLink = (link) => (
    <SidebarLink
      key={link.id}
      location={location}
      isSidebarOpened={isSidebarOpened}
      {...link}
    />
  );

  function handleWindowWidthChange() {
    const windowWidth = window.innerWidth;
    const breakpointWidth = theme.breakpoints.values.md;
    const isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map((link) => {
          if ([0,1,2,3,4,5,7].includes(link.id)) {
            if (
              user !== null &&
              user.user.roles.some(e => e.name === "ROLE_EMPLOYE" || e.name === "ROLE_SEVOB_SUPER_ADMIN")
            ) {
              return renderLink(link);
            } else {
              return null;
            }
          } else {
            return renderLink(link);
          }
        })}
      </List>
    </Drawer>
  );
}

export default Sidebar; // <-- plus besoin de withRouter